import FileUpload from "../../../../shared/components/FileUpload";

interface UploadFilesProps {
    model: string; // e.g., "product_flow.SaleOrder", "materials.MaterialOrder", "products.Customer"
    objectId: string;
    objectName?: string; // Display name for the linked object (e.g., "DBH_25_011")
    customerName?: string; // Customer name if applicable
    customerId?: string; // Customer ID for hyperlink
}

const Upload = (props: UploadFilesProps) => {
    return <FileUpload {...props} />;
};

export default Upload;
